import { createFileRoute } from "@tanstack/react-router";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import ReportList from "@/modules/report/admin/components/ReportList";
import { fetchReportsQueryOptions } from "@/modules/report/admin/services/report";

export const Route = createFileRoute("/admin/_panel/_report/report/reports/")({
  component: Component,
  pendingComponent: TableSkeleton,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "report.report.view");

    return {
      crumb: [
        {
          label: context.t("Report management", { ns: "report.admin" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(fetchReportsQueryOptions()),
});

function Component() {
  return <ReportList />;
}
